import { Box, IconButton, Modal, ModalProps, SxProps, Typography } from "@mui/material"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { sxIconButton, sxModal, sxTitleDefault } from "./sxProps";
import { useAccessibility } from "../../Store/contexts/AccessibilityContext";
import { faTimes } from "@fortawesome/free-solid-svg-icons";

export interface ModalDefaultProps extends ModalProps {
    title?: string;
    maxWidth?: string | number;
    sxTitle?: SxProps;
    className?: string;
}

export const ModalDefault: React.FC<ModalDefaultProps> = ({ children, maxWidth, sxTitle, title, className, ...props }: ModalDefaultProps) => {
    const accessibility = useAccessibility()
    const handleClose = (event: React.MouseEvent<HTMLButtonElement>) => {
        if (props.onClose) {
            props.onClose(event, 'backdropClick');
        }
    };

    return (
        <Modal
            {...props}
        >
            <Box className={className} sx={{ ...sxModal, maxWidth: maxWidth || '800px' }}>
                <Box >
                    {title && <Typography
                        style={{ ...accessibility.textStyleAccessibility, marginBottom: 24 }}
                        sx={sxTitle ? sxTitle : sxTitleDefault}
                        component="h1">
                        {title}
                    </Typography>}

                    <IconButton
                        aria-label="fechar"
                        onClick={handleClose}
                        sx={sxIconButton}
                    >
                        <FontAwesomeIcon icon={faTimes} />
                    </IconButton>
                </Box>
                {children}
            </Box>
        </Modal >
    )
}